<div class="prize-wrapper" [ngClass]="{
    'bonus-chest-bg':
      type === SPIN_WIN_PRIZES.CASINO_BONUS ||
      type === SPIN_WIN_PRIZES.CASINO_TOKEN,
    'free-spin-bg': type === SPIN_WIN_PRIZES.FREE_SPIN,
    'nft-bg': type === SPIN_WIN_PRIZES.NFT || type === SPIN_WIN_PRIZES.CUSTOM ,
    'cash-bg': type === SPIN_WIN_PRIZES.CASH,
    'custom-bg-img':prize?.prizeWinImage
  }" [ngStyle]="{ 'background-image':getBgUrl(prize.prizeWinImage)}">
  <div class="confetti-wrapper" [ngClass]="{ 'confetti-animation': showConfetti }">
    <div *ngIf="type !== SPIN_WIN_PRIZES.NFT && type !== SPIN_WIN_PRIZES.CUSTOM; else nftCard"
      class="h-100 d-flex flex-column justify-content-between align-items-center non-nft-card">
      <span class="card-title" translate>you_won</span>
      <div class="prize-details d-flex flex-row gap-2 justify-content-center align-items-center">
        <ng-container *ngIf="type !== SPIN_WIN_PRIZES.FREE_SPIN; else freeSpin">
          <img class="currency-symbol"
            [src]="prize.currency ? prize.currency.currencyImage : type === SPIN_WIN_PRIZES.CASH ? unit === CURRENCY.USD ? 'assets/images/svg-icons/usd-coin.svg' : 'assets/images/svg-icons/euro-coin.svg' :'assets/images/svg-icons/wall-token.svg'"
            [ngClass]="{'euro-coin': !prize.currency && type === SPIN_WIN_PRIZES.CASH && unit === CURRENCY.EURO}"
            alt="currency" />
          <span><span class="currency">{{ type === SPIN_WIN_PRIZES.CASH ? unit === CURRENCY.USD ? CURRENCY_SYMBOL.USD:
              CURRENCY_SYMBOL.EURO : ''}}</span>{{ value > 1 ? convertNumToCurr(value) : value
            }}&nbsp;<span class="currency">{{prize.currency?.currencyName | uppercase}}</span></span>
        </ng-container>
        <ng-template #freeSpin>
          <span class="title-class">{{prize!.numberOfFreeSpin ?? 0}}&nbsp;{{ "free" | translate | titlecase }}&nbsp;{{
            "spin" | translate |
            titlecase
            }}</span>
        </ng-template>
      </div>
    </div>
    <ng-template #nftCard>
      <div class="nft-card d-flex flex-column align-items-center">
        <span class="nft-prize-title" translate>you_won</span>
        <div class="nft-details d-flex flex-column align-items-center">
          <span class="title">{{type === SPIN_WIN_PRIZES.NFT ? 'NFT' : prize?.customPrize?.customPrizeLabel}}</span>
          <img [src]="prize.nft?.img || prize.imageUrl" alt="reward" srcset="" />
          <ng-container *ngIf="type === SPIN_WIN_PRIZES.NFT; else CustomCardTitle">
            <span class="nft-name" [tooltip]="prize.nft?.name"
              [tooltipEnable]="getEllipsis(prize.nft?.name || '', 20).includes('...')" containerClass="tooltipClass">{{
              getEllipsis(prize.nft?.name || '', 20) }}</span>
            <span class="nft-id title-text" [tooltip]="(prize.nft?.id || '').toString()"
              [tooltipEnable]="getEllipsis((prize.nft?.id || '').toString() , 20).includes('...')"
              containerClass="tooltipClass">#{{
              getEllipsis((prize.nft?.id || '').toString() , 20)
              }}</span>
          </ng-container>
          <ng-template #CustomCardTitle>
            <span class="nft-name" [tooltip]="prize?.customPrize?.customPrizeDesc"
              [tooltipEnable]="getEllipsis(prize?.customPrize?.customPrizeDesc || '', 20).includes('...')"
              containerClass="tooltipClass">{{ getEllipsis(prize?.customPrize?.customPrizeDesc || '', 20) }}</span>
          </ng-template>
        </div>
        <span class="info text-center" *ngIf="type === SPIN_WIN_PRIZES.NFT || type === SPIN_WIN_PRIZES.CUSTOM"
          translate>{{type === SPIN_WIN_PRIZES.CUSTOM ? 'won_custom_prize' : 'sell_NFT_info'}}</span>

        <div class="action-section d-flex flex-row align-items-center">
          <button class="w-100 keep-nft-btn btn primary-btn" (click)="claimPrize()">
            {{(type === SPIN_WIN_PRIZES.NFT ? "keep_my_nft" : prize?.customPrize?.isResalable ? 'Keep Prize' : "Okay") |
            translate }}
          </button>
          <button class="w-100 sell-nft-btn btn primary-outline-btn" (click)="sellNFT()"
            *ngIf="type === SPIN_WIN_PRIZES.NFT || prize?.customPrize?.isResalable">
            {{"sell_for" | translate}} {{unit === CURRENCY.USD ? CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO}}{{
            convertNumToCurr(value)}}
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>